import {
  GET_ALL_HELP_REQUESTS,
  GET_HELP_REQUESTS,
  GET_HELP_REQUEST,
  RESET_HELP_REQUESTS,
  GET_SCREENSHOT_IMAGE,
} from './types'

const initialState = {
  help_requests: [],
  help_request: {},
  loading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_HELP_REQUEST:
      return {
        ...state,
        help_requests: action.payload,
      }
    case GET_HELP_REQUESTS:
      return {
        ...state,
        help_requests: action.payload,
      }
    case GET_ALL_HELP_REQUESTS:
      return {
        ...state,
        help_requests: action.payload,
      }
    case RESET_HELP_REQUESTS:
      return {
        ...state,
        help_requests: action.payload,
      }
    case GET_SCREENSHOT_IMAGE:
      return {
        ...state,
        help_requests: { ...state.help_requests, screenshot: action.payload },
      }
    default:
      return state
  }
}
